import { baseBackend } from "../../../../api/base/baseUrl";

const headerGeneral = {
  headers: { "Content-Type": "application/json" },
};

export const getEnterpriseRatesBase = async (enterpriseId) => {
  return await baseBackend.get(
    `/api/v2/rates/enterprise/enterprise/${enterpriseId}`,
    headerGeneral,
  );
};
